<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                tableHeader
              }}</span>
            </h3>
            <div class="card-toolbar">
              <button
                class="btn btn-icon btn-active-light-primary cursor-pointer"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
              >
                <i class="fa-solid fa-filter"></i>
              </button>
            </div>
          </div>

          <!-- List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- Filters -->
              <div class="collapse mb-8" id="collapseExample">
                <form (submit)="filterList($event)">
                  <div class="row">
                    <div
                      class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3"
                      *ngIf="hasFilter('customerCode')"
                    >
                      <label for="Customer Code" class="form-label"
                        >Customer Code</label
                      >
                      <div class="position-relative">
                        <select
                          [(ngModel)]="filterForm.customerCode"
                          class="form-select cursor-pointer pe-5"
                          aria-label="Small select example"
                          name="Customer Code"
                        >
                          <option [ngValue]="''" selected disabled>
                            Select Customer Code
                          </option>
                          <option
                            *ngFor="let customerCode of customerCodes"
                            [value]="customerCode?.code"
                          >
                            {{ customerCode?.code }}
                          </option>
                        </select>
                        <button
                          type="button"
                          class="btn-close position-absolute top-50 custom-end-0 translate-middle"
                          (click)="filterForm.customerCode = ''"
                          aria-label="Clear customer code"
                        ></button>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3"
                      *ngIf="hasFilter('doctor')"
                    >
                      <label for="Doctor" class="form-label">Doctor</label>
                      <div class="position-relative">
                        <select
                          [(ngModel)]="filterForm.doctor"
                          class="form-select cursor-pointer pe-5"
                          aria-label="Small select example"
                          name="Doctor"
                        >
                          <option [ngValue]="''" selected disabled>
                            Select Doctor
                          </option>
                          <option
                            *ngFor="let expert of expertList"
                            [value]="expert?.id"
                          >
                            {{ expert?.name }}
                          </option>
                        </select>
                        <button
                          type="button"
                          class="btn-close position-absolute top-50 custom-end-0 translate-middle"
                          (click)="filterForm.doctor = ''"
                          aria-label="Clear doctor"
                        ></button>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3"
                      *ngIf="hasFilter('year')"
                    >
                      <label for="year" class="form-label">Year</label>
                      <div class="position-relative">
                        <select
                          [(ngModel)]="filterForm.year"
                          class="form-select pe-5"
                          id="year"
                          name="year"
                        >
                          <option value="null" disabled selected>
                            Select year
                          </option>
                          <option
                            *ngFor="let year of getYears()"
                            [value]="year"
                          >
                            {{ year }}
                          </option>
                        </select>
                        <button
                          type="button"
                          class="btn-close position-absolute top-50 custom-end-0 translate-middle"
                          (click)="filterForm.year = null"
                          aria-label="Clear year"
                        ></button>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3"
                      *ngIf="hasFilter('month')"
                    >
                      <label for="month" class="form-label">Month</label>
                      <div class="position-relative">
                        <select
                          [(ngModel)]="filterForm.month"
                          class="form-select pe-5"
                          id="month"
                          name="month"
                        >
                          <option value="null" disabled selected>
                            Select month
                          </option>
                          <option
                            *ngFor="let month of months"
                            [value]="month.value"
                          >
                            {{ month.name }}
                          </option>
                        </select>
                        <button
                          type="button"
                          class="btn-close position-absolute top-50 custom-end-0 translate-middle"
                          (click)="filterForm.month = null"
                          aria-label="Clear month"
                        ></button>
                      </div>
                    </div>

                    <!-- Filter Action Buttons -->
                    <div
                      class="col-xl-6 col-lg-3 col-md-4 col-sm-6 mt-8 text-end"
                    >
                      <button
                        (click)="clearFilters()"
                        type="button"
                        class="btn btn-secondary cursor-pointer"
                      >
                        Clear
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary cursor-pointer ms-4"
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Table -->
              <table
                class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
              >
                <thead>
                  <tr class="fw-bold text-muted">
                    <th
                      class="text-gray-600 min-w-120px fw-bold"
                      *ngFor="let item of columns"
                    >
                      {{ item | columnName }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of data">
                    <td
                      class="text-gray-900 text-hover-primary fs-6"
                      *ngFor="let key of columns"
                    >
                      <ng-container
                        *ngIf="key === 'month'; else defaultContent"
                      >
                        {{ (row[key] | monthName) || "-" }}
                      </ng-container>
                      <ng-template #defaultContent>
                        {{ row[key] || "-" }}
                      </ng-template>
                    </td>
                  </tr>
                  <tr>
                    <ng-container *ngFor="let key of columns; let i = index">
                      <td *ngIf="i < columns.length - 1"></td>
                      <td
                        *ngIf="i === columns.length - 1"
                        class="text-gray-900 text-hover-primary fs-6"
                      >
                        Total: {{ getTotalForLastColumn() }}
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label
                for="pageSizeSelect"
                class="me-2 fs-6 fw-semibold text-gray-700"
                >Page Size:</label
              >
              <select
                id="pageSizeSelect"
                (change)="changePageSize($event)"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              Showing {{ data.length }} of {{ totalCount }} users
            </div>
          </div>
          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>
            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>
            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-toast
    [message]="toastMessage"
    [type]="toastType"
    [showToast]="showToast"
  ></app-toast> -->
